import React, { useEffect, useState, useRef } from "react";
// import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Box, FormControlLabel, Grid, Paper, FormControl } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as GoogleIcon } from "../../assets/images/ri_google-fill.svg";
import { ReactComponent as GitHubIcon } from "../../assets/images/github-line.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/images/ri_linkedin-fill.svg";
import { ReactComponent as FacebookIcon } from "../../assets/images/ri_facebook-fill.svg";
import styles from "./styles";
import { Divider } from "@mui/material";
import CustomInput from "../../components/CustomInput";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "../../hooks/useForm";
import { signUpData } from "../../constants/data";
import { SignUpValidate } from "../../helper/Validation";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
import { LoadingButton } from "@mui/lab";
// import CircularIndeterminate from "../../utils/Alert/LoginAlert";
import Carousel from "react-material-ui-carousel";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

// const settings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 2000,
// };
 
 
 
 
const SignupPage = ({ handleSignUp,loading }) => {
  const navigate = useNavigate();
 
  useEffect(() => {
    const Token = localStorage.getItem("accessToken");
    if (Token) {
      navigate("/companyInfo");
    }
  }, []);

 
  const handleSignOut = async (data) => {
    handleSignUp(data);
  }
  const { state, handleChange, handleSubmit, handleFocus, disable } = useForm(
    signUpData,
    SignUpValidate,
    handleSignOut,
  );
  const { firstName, lastName, email, password, confirmPassword, terms } = state;
  const [mobile, setMobile] = useState("");
  const [cCode, setCCode] = useState("");
  const mobileNumberRef = useRef(null);

  const handlePhoneChange = (value, country) => {
    const dialCode = country?.dialCode || "";
    const phoneNumberPart = value.startsWith(dialCode) ? value.slice(dialCode.length) : value;
    setMobile(value);
    setCCode("+" + dialCode);
    handleChange("phone", phoneNumberPart);
    handleChange("countryCode", "+" + dialCode);
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
 
 
  return (
    <>
 
      {/* {loading && <CircularIndeterminate />} */}
      <Box sx={styles.boxStyle}>
        
        <Container sx={styles.root} >
          <Paper sx={styles.paper}>
 
            <Grid container sx={styles.gridContainer}>
              <Grid item xs={12} sm={12} md={6} sx={styles.gridItem}>
                <Container maxWidth="sm">
                  <Box mt={2}>
                    <Box>
                      <Typography variant="h4" sx={styles.mainheading}>
                      Create New Account
                      </Typography>
                      <Box sx={styles.headingborder}></Box>
                    </Box>
                    <form onSubmit={handleSubmit} className={styles.form} autoComplete="off">
                      <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography sx={styles.inputText}>First Name</Typography>
                          <CustomInput
                            variant="outlined"
                            required
                            fullWidth
                            id="firstName"
                            error={firstName?.error}
                            name="firstName"
                            value={firstName?.value}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            autoComplete="lname" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography sx={styles.inputText}>Last Name</Typography>
                          <CustomInput
                            variant="outlined"
                            required
                            fullWidth
                            id="lastName"
                            value={lastName?.value}
                            error={lastName?.error}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            name="lastName"
                            autoComplete="lname" />
                        </Grid>
                      </Grid>
                      <Box sx={{ mt: 1 }}>
                        <FormControl fullWidth sx={styles.mobileGrid} >
                          <Typography sx={styles.inputText}>Phone</Typography>
                          <PhoneInput
                            country={"za"}
                            enableSearch={true}
                            value={mobile}
                            name="mobile"
                            onChange={(value, country) => handlePhoneChange(value, country)}
                            onFocus={handleFocus}
                            ref={mobileNumberRef}
                            sx={styles.mobile}
                            inputProps={{
                              style: {
                                height: "1em",
                                borderRadius: "10px",
                                width: "100%"
                              },
                            }}
                          />
                        </FormControl>
                      </Box>
                      <Box mt={1}>
                        <Typography sx={styles.inputText}>Email Address</Typography>
                        <CustomInput
                          fullWidth
                          error={email?.error}
 
                          name="email"
                          type="email"
                          value={email?.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          variant="outlined"
                          required />
                      </Box>
                      <Box mt={1}>
                        <Typography sx={styles.inputText}>New Password</Typography>
                        <CustomInput
                          fullWidth
                          error={password?.error}
                          name="password"
                          type={"password"}
                          value={password?.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          variant="outlined"
                          required
                          altrName="password" />
                      </Box>
                      <Box mt={1}>
                        <Typography sx={styles.inputText}>Confirm Password</Typography>
                        <CustomInput
                          fullWidth
                          error={confirmPassword?.error}
                          altrName="password"
                          name="confirmPassword"
                          type={"password"}
                          value={confirmPassword?.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          variant="outlined"
                          required
                          matchPassword={password.value} />
                      </Box>
 
 
                      <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
 
                        <FormControlLabel
                          control={<Checkbox {...label} defaultChecked style={styles.checkbox} 
                            checked={terms?.value}
 
                          />}
                          onChange={(e) =>
                            handleChange("terms", e.target.checked)}
    
                          label={<Typography sx={styles.termsConditionText}>
                          I accept the <Link to="/terms" style={styles.forgotlink}>Terms and conditions</Link>
                          </Typography>} />
                      </Grid>
                      <LoadingButton 
                        loading={loading}
                        type="submit"
                        variant="contained"
                        color="black"
                        fullWidth
                        size="large"
                        disabled={disable}
                        sx={styles.submit}
                      >
                      Sign Up
                      </LoadingButton>
                      
                    </form>
 
                    <Grid container sx={styles.orSection} spacing={{ xs: 3, sm: 3, lg: 10, xl: 10 }}>
                      <Grid item xs={4}>
                        <Divider sx={styles.divider} />
                      </Grid>
                      <Grid item xs={2} container sx={styles.orBox}>
                        <Typography variant="body1" sx={styles.orText}>or</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Divider sx={styles.divider} />
                      </Grid>
                    </Grid>
                    <Box sx={styles.socialIcons}>
                      <GoogleIcon style={styles.icon} />
                      <FacebookIcon style={styles.icon} />
                      <LinkedInIcon style={styles.icon} />
                      <GitHubIcon style={styles.icon} />
                    </Box>
 
                    <Typography sx={styles.inputText}>Already have an account? <Link to="/" style={styles.forgotlink}>Login </Link></Typography>
                    <Box sx={styles.privacyCondition}>
                      <Box>
                        <Typography sx={styles.termsText}>Privacy</Typography>
                      </Box>
                      <Box sx={styles.greyDot} /><Box>
                        <Box>
                          <Typography sx={styles.termsText}>Terms and Conditions</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Container> 
              </Grid>
              {/* <Hidden xsDown> */}
              <Grid item xs={12} sm={12} md={6} >
                <Carousel indicators={false}>
                  <Box sx={styles.image}>
                    <Box sx={styles.backgroundImage}></Box>
                    <Typography sx={styles.sliderText}>Ensure the security of your online accounts with 100% security. Safeguard OTP secrets with backup options,
guaranteeing access to your accounts.</Typography>
                    <Box sx={styles.dots}>
                      <Box sx={styles.dot2}></Box>
                      <Box sx={styles.dot1}></Box>                   
                    </Box>
                  </Box>
                  <Box sx={styles.image}>
                    <Box sx={styles.backgroundImage2}></Box>
                    <Typography sx={styles.sliderText}>OTP secrets with backup options, 
guaranteeing access to your accounts. Ensure the security of your online accounts with 100% security. Safeguard.</Typography>
                    <Box sx={styles.dots}>
                      <Box sx={styles.dot1}></Box>
                      <Box sx={styles.dot2}></Box>                   
                    </Box>
                  </Box>
                </Carousel>
              
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Box>
    </>
 
  );
};
 
export default SignupPage;
 